import { render, staticRenderFns } from "./changeUserInfo.vue?vue&type=template&id=436b4450&scoped=true&"
import script from "./changeUserInfo.vue?vue&type=script&lang=js&"
export * from "./changeUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./changeUserInfo.vue?vue&type=style&index=0&id=436b4450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b4450",
  null
  
)

export default component.exports